import React from 'react'
import { TaskCard, TaskBoardType } from '../../types/task-board'
import { getUserColor } from '../../utils/userColors'

interface TaskCardAssigneeProps {
  card: TaskCard
  board: TaskBoardType
  onAssignUser: (userId: string | null) => Promise<void>
}

export const TaskCardAssignee: React.FC<TaskCardAssigneeProps> = ({ card, board, onAssignUser }) => {
  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '5px', marginBottom: '20px', overflow: 'hidden' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: window.innerWidth < 768 ? '8px 10px' : '10px 15px', borderBottom: '1px solid #e9ecef' }}>
        <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, margin: 0 }}>
          Osoba odpowiedzialna
        </h4>
      </div>
      <div style={{ padding: window.innerWidth < 768 ? '10px' : '15px', maxHeight: '150px', overflowY: 'auto' }}>
        {board.members.map(member => (
          <div
            key={member.id}
            onClick={async () => {
              await onAssignUser(member.id)
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 10px',
              marginBottom: '8px',
              cursor: 'pointer',
              backgroundColor: card.assignedTo?.id === member.id ? '#e6f7e8' : '#fff',
              border: `1px solid ${card.assignedTo?.id === member.id ? '#28a745' : '#dee2e6'}`,
              borderRadius: '4px',
              transition: 'all 0.2s ease'
            }}
          >
            {member.username && (
              <div
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  marginRight: '10px',
                  backgroundColor: getUserColor(member.username),
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}
                title={member.username}
              >
                {member.username.charAt(0).toUpperCase()}
              </div>
            )}
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '14px', fontWeight: 500 }}>{member.username}</div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>{member.email}</div>
            </div>
            {card.assignedTo?.id === member.id && (
              <div style={{ color: '#28a745', fontSize: '16px' }}>✓</div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
